import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/rolodex/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { rolodexBaseQuery } from './baseQuery';

const ROLODEX_API_REDUCER_PATH = 'api/rolodex' as const;

export const rolodexApiRoot = createApi({
  reducerPath: ROLODEX_API_REDUCER_PATH,
  baseQuery: rolodexBaseQuery,
  keepUnusedDataFor: 5 * 60,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
